<template>
  <Layout :style="{minHeight: bodyHeight}">
    <Layout>
      <gSwiper></gSwiper>
    </Layout>
    <Layout>
      <Sider hide-trigger collapsible :collapsed-width="78" style="width: 255px;min-width: 255px;">
        <div class="side-logo">
          <img v-if="true" src="@assets/img/exhibition/logo-1.png" style="display: inline-block;" @click="$router.push('/exhibition/index/home')" class="f-csp" />
          <!-- <img
          v-if="exhibition.logo"
          :src="exhibition.logo"
          :alt="exhibition.name"
          :title="exhibition.name"
          @click="$router.push('/exhibition/index/home')"
          class="f-csp"
          style="width: 32px;height: 32px;"
          />-->
          <img src="@assets/img/exhibition/logo.png" alt="云展台" title="云展台" @click="$router.push('/exhibition/index/home')" class="f-csp" v-else />
        </div>
        <gSide :siderArr="siderArr"></gSide>
      </Sider>
      <Layout style="height: 100%;width:calc(100% - 255px);" :style="{minHeight: bodyHeight}">
        <Header :style="{padding: 0}" class="layout-header-bar">
          <gHead :typeNum="1"></gHead>
        </Header>
        <Content>
          <div :style="{minHeight: '500px'}">
            <router-view />
          </div>
        </Content>
        <Footer>
          <copyright />
        </Footer>
      </Layout>
    </Layout>
    <Contact />
  </Layout>
</template>

<script>
import gHead from "@components/gHead/gHead";
import gSide from "@components/gSide/gSide";
import copyright from "@components/copyright/copyright";
import Contact from "@components/Contact/Contact";
import gSwiper from "@components/gSwiper/gSwiper.vue";
import { mapGetters } from "vuex";
export default {
  name: "exhibition-layout",
  data () {
    return {
      bodyHeight: "800px",
      siderArr: [
        {
          title: "首页",
          icon: "icon-shouye11",
          router: "/exhibition/index/home",
          type: 1,
        },
        {
          title: "光地搭建",
          icon: "icon-zhuangxiu",
          router: "/exhibition/index/build",
          type: 1,
        }, 
        {
          title: "标摊楣板",
          icon: "icon-zhaopaisheji",
          router: "/exhibition/index/exinfo/fascia-board",
          type: 1
        },
        {
          title: "展商胸卡",
          icon: "icon-idcard-examine",
          router: "https://bakerychina.7-event.cn/exhibitor/login",
          type: 1
        },
        {
          title: "观众胸卡",
          icon: "icon-zhengjian3",
          router: "https://bakerychina.7-event.cn/",
          type: 1
        },
        {
          title: "车证办理",
          icon: "icon-buchezhanchezheng",
          router: "/exhibition/index/empty",
          type: 1
        },
        {
          title: "更多参展服务",
          icon: "icon-download",
          router: "/exhibition/index/exinfo/down",
          type: 1
        },
        {
          title: "注意事项",
          icon: "icon-zhuyi",
          router: "/exhibition/index/exinfo/tip",
          type: 1
        },
        {
          title: "联系人",
          icon: "icon-lianxiren",
          router: "/exhibition/index/exinfo/concact",
          type: 1
        },
        // {
        //   title: "订单中心",
        //   icon: "icon-dingdanzhongxin",
        //   router: "/exhibition/index/order",
        //   type: 1
        // },
        // {
        //   title: "图集管理",
        //   icon: "icon-sucaiku1",
        //   router: "/exhibition/index/photo",
        //   type: 1
        // },
        // {
        //   title: "参展",
        //   icon: "icon-diamonds",
        //   type: 2,
        //   children: [
        // {
        //   title: "我的展位图",
        //   router: "/exhibition/index/exinfo/boothImg"
        // },
        // {
        //   title: "会刊提交",
        //   router: "/exhibition/index/exinfo/catalogue"
        // },
        // {
        //   title: "展商证申请",
        //   router: "/exhibition/index/exinfo/certApply"
        // },
        // {
        //   title: "楣板信息",
        //   router: "/exhibition/index/exinfo/fascia-board"
        // },
        // {
        //   title: "确认发票",
        //   router: "/exhibition/index/exinfo/invoice"
        // },
        // {
        //   title: "车证申请",
        //   router: "/exhibition/index/exinfo/carApply"
        // },
        // {
        //   title: "更多参展服务",
        //   router: "/exhibition/index/exinfo/down"
        // },
        // {
        //   title: "采买咨询",
        //   router: "/exhibition/index/exinfo/buyConsult"
        // },
        // {
        //   title: "注意事项",
        //   router: "/exhibition/index/exinfo/tip"
        // }
        //   ]
        // },
        // {
        //   title: "推广",
        //   icon: "icon-yijicaidanalituku_tuiguang",
        //   type: 2,
        //   children: [
        //     {
        //       title: "商机",
        //       router: "/exhibition/index/business"
        //     },
        //     {
        //       title: "商机",
        //       router: "/exhibition/index/release"
        //     },
        //     {
        //       title: "供需",
        //       router: "/exhibition/index/release-new"
        //     },
        //     {
        //       title: "动态",
        //       router: "/exhibition/index/moment"
        //     },
        //   ]
        // },
        // {
        //   title: "我的云店",
        //   icon: "icon-guanli",
        //   type: 2,
        //   children: [
        //     {
        //       title: "云店设置",
        //       router: "/exhibition/index/template"
        //     },
        //     {
        //       title: "上传产品",
        //       router: "/exhibition/index/product"
        //     },
        //     {
        //       title: "产品展示组",
        //       router: "/exhibition/index/proGroup/productlist"
        //     },
        //     {
        //       title: "活动计划",
        //       router: "/exhibition/index/activity"
        //     },
        // {
        //   title: "贸易洽谈",
        //   router: "/exhibition/index/Trade"
        // },
        // {
        //   title: "人员",
        //   router: "/exhibition/index/companyAdmin"
        // },
        // {
        //   title: "案例",
        //   router: "/exhibition/index/case"
        // },
        // {
        //   title: "旗下品牌",
        //   router: "/exhibition/index/brand"
        // },
        // {
        //   title: "合作医院",
        //   router: "/exhibition/index/partner"
        // },
        //     {
        //       title: "资质证书",
        //       router: "/exhibition/index/certificate"
        //     },
        //     {
        //       title: "素材库",
        //       router: "/exhibition/index/material"
        //     }
        //   ]
        // },
        {
          title: "企业中心",
          icon: "icon-shezhi1",
          type: 2,
          children: [
            // {
            //   title: "公司信息",
            //   router: "/exhibition/index/companyInfo"
            // },
            // {
            //   title: "管理员资料",
            //   router: "/exhibition/index/companyAdmin"
            // },
            // {
            //   title: "产品展示组",
            //   router: "/exhibition/index/proGroup/productlist"
            // },
            // {
            //   title: "企业动态",
            //   router: "/exhibition/index/news"
            // },
            // {
            //   title: "分享设置",
            //   router: "/exhibition/index/share"
            // },
            {
              title: "账户安全",
              router: "/exhibition/index/companyAccount"
            }
          ]
        }
      ]
    };
  },
  components: {
    gHead,
    gSide,
    Contact,
    copyright,
    gSwiper
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition"
    }),
  },
  created () {
    this.bodyHeight = window.innerHeight ? window.innerHeight + "px" : "800px";
    document.title = "国际焙烤展";
  },
};
</script>

<style lang="scss">
body {
  padding-right: 0 !important;
}
</style>
<style scoped lang='scss'>
.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.side-logo {
  text-align: center;
  height: 64px;
  background-color: #fff;
  img {
    height: 60px;
  }
}
</style>
